import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/73e3c9e7-79ff-49bf-96d1-913f017896c5/images/a9e2b62feb14c46d35f95c511b3d6a77a3c565bb5c84db8ec5020d167d572b70.png",
  portal: "https://static.prod-images.emergentagent.com/jobs/73e3c9e7-79ff-49bf-96d1-913f017896c5/images/51088eb6773131b9cec9b60dd56e30d06728e0b4e6c042d4c6ac7a3d50fa0a72.png",
  about: "https://static.prod-images.emergentagent.com/jobs/73e3c9e7-79ff-49bf-96d1-913f017896c5/images/f510ed1a25b959bf3e2236dd3d81adda9b4e7205b9e496ed1dd2d25821ba7c78.png",
  sound: "https://static.prod-images.emergentagent.com/jobs/73e3c9e7-79ff-49bf-96d1-913f017896c5/images/fce0f337adebad6f0fc04999e08e686165307bcd5a488f1069c5f819c77a3615.png",
};

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
